import React from 'react';
import { FormContainer, MultiSelectElement } from 'react-hook-form-mui';
import { DatePickerElement } from 'react-hook-form-mui/date-pickers';
import { Stack } from '@mui/material';

import { useAuth, useBusinessSelector } from '@barboxx/admin-utils';
import { ORDER_STATUS } from '@barboxx/types';
import { enumToFormOptions, getCurrentBusinessDayDate } from '@barboxx/utils';

import {
    CustomPageHeader,
    RootContainer,
} from '../../components/nav/RootContainer';
import { OrdersSummary } from './components/OrdersSummary';

export function SalesList() {
    const {
        auth: { user },
    } = useAuth();
    const { businessId, businessList } = useBusinessSelector();

    const selectedBusiness = React.useMemo(() => {
        if (businessId) {
            return businessList.find(business => business.id === businessId);
        }

        if (user.userType === 'Business' && businessList.length === 1) {
            return businessList[0];
        }

        return undefined;
    }, [businessId, businessList, user.userType]);

    const currentBusinessDayDate = React.useMemo(
        () =>
            getCurrentBusinessDayDate(new Date(), {
                hoursOfOperations: selectedBusiness?.place?.hoursOfOperations,
            }),
        [selectedBusiness?.place?.hoursOfOperations]
    );

    const defaultValues = React.useMemo(
        () => ({
            status: [ORDER_STATUS.Completed, ORDER_STATUS.Trashed],
            startedAt: currentBusinessDayDate,
            endedAt: currentBusinessDayDate,
        }),
        [currentBusinessDayDate]
    );

    const CustomPageToolbarComponent = React.useCallback(
        () => (
            <CustomPageHeader>
                <Stack gap={2} flexDirection="row">
                    {user.userType === 'Internal' && (
                        <MultiSelectElement
                            name="status"
                            label="Statuses"
                            options={enumToFormOptions(ORDER_STATUS)}
                            multiple
                        />
                    )}
                    <DatePickerElement
                        name="startedAt"
                        label="Start date"
                        // maxDate={endedAt}
                        formatDensity="dense"
                        disableFuture
                    />
                    <DatePickerElement
                        name="endedAt"
                        label="End date"
                        formatDensity="dense"
                        disableFuture
                        // minDate={startedAt}
                    />
                </Stack>
            </CustomPageHeader>
        ),
        [user.userType]
    );

    return (
        <FormContainer defaultValues={defaultValues}>
            <RootContainer
                maxWidth={false}
                slots={{ header: CustomPageToolbarComponent }}
            >
                <Stack gap={2}>
                    <OrdersSummary />
                </Stack>
            </RootContainer>
        </FormContainer>
    );
}
